import { cn } from '@/lib/cn';
import type { IvrNodeType } from '@/api/ivrNodes';

// Node types supported by the MVP interpreter
export const MVP_TYPES = new Set<IvrNodeType>(['playback', 'menu', 'transfer', 'jump']);

// Color mapping by node type category
function typeColor(t: IvrNodeType): string {
  if (t === 'playback') return 'bg-blue-50 text-blue-700 border-blue-200';
  if (t === 'menu') return 'bg-violet-50 text-violet-700 border-violet-200';
  if (t === 'transfer' || t === 'ring_group' || t === 'dial' || t === 'sip_connect') return 'bg-orange-50 text-orange-700 border-orange-200';
  if (t === 'jump' || t === 'back' || t === 'repeat' || t === 'return_to_bookmark') return 'bg-amber-50 text-amber-700 border-amber-200';
  if (t === 'conference' || t === 'voicemail' || t === 'listen_voicemail') return 'bg-teal-50 text-teal-700 border-teal-200';
  if (t === 'survey' || t === 'quiz' || t === 'enrollment') return 'bg-green-50 text-green-700 border-green-200';
  if (t === 'payment' || t === 'shopping') return 'bg-emerald-50 text-emerald-700 border-emerald-200';
  if (t === 'admin' || t === 'custom') return 'bg-slate-100 text-slate-600 border-slate-200';
  return 'bg-slate-50 text-slate-500 border-slate-200';
}

interface Props {
  type: IvrNodeType;
  showMvpPill?: boolean;
  className?: string;
}

export function NodeTypeBadge({ type, showMvpPill = false, className }: Props) {
  const isMvp = MVP_TYPES.has(type);
  return (
    <span className={cn('inline-flex items-center gap-1', className)}>
      <span
        className={cn(
          'inline-block rounded border px-1.5 py-0.5 font-mono text-[11px] leading-none font-medium',
          typeColor(type),
        )}
      >
        {type}
      </span>
      {showMvpPill && isMvp && (
        <span className="inline-block rounded bg-amber-400/20 border border-amber-300 px-1 py-0.5 text-[9px] font-semibold uppercase tracking-wide leading-none text-amber-700">
          MVP
        </span>
      )}
    </span>
  );
}
